import { MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/site";

export default function WhatsAppButton() {
  const url = `https://wa.me/${BRAND.phoneRaw}?text=${encodeURIComponent(BRAND.whatsappMsg)}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-2xl hover:scale-110 transition-transform"
    >
      <MessageCircle size={26} fill="currentColor" />
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" />
    </a>
  );
}
